export default {
  'financial.billsToReceive.form.situation': 'Situation',
  'financial.billsToReceive.form.situation.open': 'Open',
  'financial.billsToReceive.form.situation.liquidated': 'Liquidated',
  'financial.billsToReceive.form.filterByDate': 'Filter By Date',
  'financial.billsToReceive.form.filterByDate.issue': 'Issue',
  'financial.billsToReceive.form.filterByDate.maturity': 'Maturity',
  'financial.billsToReceive.form.filterByDate.receipt': 'Receipt',
  'financial.billsToReceive.form.reportType': 'Select the Report Type',
  'financial.billsToReceive.form.reportType.issue': 'Issue',
  'financial.billsToReceive.form.reportType.maturity': 'Maturity',
  'financial.billsToReceive.form.reportType.receipt': 'Receipt',
  'financial.billsToReceive.form.reportType.chartOfAccounts':
    'Chart Of Accounts',
  'financial.billsToReceive.form.synthetic': 'Synthetic',
  'financial.billsToReceive.form.analitic': 'Analitic',
  'financial.billsToReceive.form.orderBy': 'Order By',
  'financial.billsToReceive.form.orderBy.date': 'Date',
  'financial.billsToReceive.form.orderBy.description': 'Description',
  'financial.billsToReceive.form.orderBy.debtor': 'Debtor',
  'financial.billsToReceive.form.orderBy.code': 'Code',
  'financial.billsToReceive.form.orderBy.planAccount': 'Chart Of Accounts',
  'financial.billsToReceive.form.orderBy.documentType': 'Type Of Documents',
  'financial.billsToReceive.form.moreOptions': 'More Options',
  'financial.billsToReceive.form.moreOptions.documentsTypes': 'Documents Types',
  'financial.billsToReceive.form.moreOptions.insurers': 'Insurers',
  'financial.billsToReceive.form.moreOptions.banks': 'Bank Account',
  'financial.billsToReceive.form.moreOptions.ChartOfAccounts':
    'Chart Of Accounts',
  'financial.billsToReceive.form.moreOptions.selectCustomers':
    'Select Customers',
};
